import React from "react"
import Availability from "./Availability"
import "./Pdp.css"

const Details = props => (
  <li className="PDP-Details">
    <a href={props.page}>
      <div className="PDP-Details-Contents">
        <strong className="PDP-Price">£{props.price}</strong>
        <Availability level="high" stock="Good stock levels" />
        <div className="PDP-Memory">
          <h5 className="PDP-Title">Select your capacity</h5>
          {props.storage}
        </div>
        <div className="PDP-Colours">
          <h5 className="PDP-Title">Choose your colour</h5>
          {props.colours}
        </div>
        <div className="PDP-Connection">
          <h5 className="PDP-Title">Choose your connection</h5>
          {props.connection}
        </div>
        <h5 className="PDP-Title-Bold">Quantity</h5>
        <select>
          <option>1</option>
        </select>
        {props.accessories}
        <a className="PDP-Details-Button" href="/shop">
          Add to basket
        </a>
      </div>
    </a>
  </li>
)

export default Details
